module.exports = __webpack_public_path__ + "images/166_2048.jpg";